<template>
<div>
  <v-dialog v-model="changePasswordDialog" max-width="500px">
    <v-card>
      <v-form v-on:submit.prevent="changePassword" v-model="valid" ref="changePasswordForm">
        <v-card-title>
          <v-layout wrap>
              <v-flex xs12>
                <h1>Actualizar contraseña </h1><br/>
              </v-flex>
              <v-flex xs12 v-if="user">
                <h3 >{{user.name}}</h3>
              </v-flex>
          </v-layout>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field name="password" label="Nueva contraseña"
                type="password" v-model="password" v-on:keyup.enter="changePassword"></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field name="confirmPassword" label="Confirme contraseña"
                type="password" v-model="confirmPassword"></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="closeDialog">Cancelar</v-btn>
          <v-btn type="submit" color="success">Guardar</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
export default {
  props: {
    user: {
      type: Object,
      default: undefined,
    },
    changePasswordDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      password: '',
      confirmPassword: '',
      valid: true,
    };
  },
  methods: {
    async changePassword() {
      this.$emit('close-dialog');
      if (this.password !== this.confirmPassword) {
        this.error = 'Las contraseñas no coinciden';
        return;
      }
      const parameters = {
        password: this.password,
        confirmPassword: this.confirmPassword,
      };

      let changePasswordEndpoint = '/users/me/changePassword';
      if (this.user) {
        changePasswordEndpoint = `/users/${this.user.id}/changePassword`;
      }
      try {
        const results = await this.axios.put(changePasswordEndpoint, parameters);
        this.$emit('change-password', {
          status: results.status,
        });
      } catch (error) {
        this.$emit('error', error);
      } finally {
        this.password = '';
        this.confirmPassword = '';
      }
    },
    closeDialog() {
      this.password = '';
      this.confirmPassword = '';
      this.$emit('close-dialog');
    },
  },
};
</script>
